import { render, staticRenderFns } from "./OtpChart.vue?vue&type=template&id=bad217ac&scoped=true"
import script from "./OtpChart.vue?vue&type=script&lang=js"
export * from "./OtpChart.vue?vue&type=script&lang=js"
import style0 from "./OtpChart.vue?vue&type=style&index=0&id=bad217ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad217ac",
  null
  
)

export default component.exports